module.exports = __webpack_public_path__ + "static/media/object.6495140c.gif";